// import Home from '@/views/Home.vue';

export default {
    path: '/',
    name: 'home',
    redirect: { name: 'inspectionsSummary' },
    component: () => import(/* webpackChunkName: "Home" */ '../../views/Home.vue')
};
